import type { ReactNode } from 'react';

import { BulletList_Box_1, List } from './BulletList.styled';

type Props = {
  items: {
    key: string | number;
    value: ReactNode;
  }[];
  columns?: 1 | 2;
  itemMargin?: number;
  mt?: number;
  qaId?: string;
};

export function BulletList({
  items,
  columns = 1,
  itemMargin = 0,
  mt,
  qaId,
}: Props) {
  return (
    <List
      style={{
        display: 'flex',
        marginBottom: -itemMargin,
        marginTop: mt,
      }}
      data-qa-id={qaId}
    >
      {items.map(
        ({ key, value }) =>
          value && (
            <BulletList_Box_1
              key={key}
              style={{
                marginBottom: `${itemMargin}px`,
                '--w-md': (100 / columns).toFixed(2) + '%',
              }}
            >
              {value}
            </BulletList_Box_1>
          ),
      )}
    </List>
  );
}
